import { Sketch } from 'vue-color';

let defaultProps = {
  hex: '#194d33e6',
  hsl: {
    h: 150,
    s: 0.5,
    l: 0.2,
    a: 0.9,
  },
  hsv: {
    h: 150,
    s: 0.66,
    v: 0.3,
    a: 0.9,
  },
  rgba: {
    r: 159,
    g: 96,
    b: 43,
    a: 0.9,
  },
  a: 0.9,
};

const mixinColors = {
  components: {
    'sketch-picker': Sketch,
  },

  data() {
    return {
      renderComponent: true,
      colors: '#194d33',
      colorst: '#000000',
    };
  },

  computed: {
    bgc() {
      return this.colors.hex;
    },
  },

  methods: {
    forceRerender() {
      // remove the my-component component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // add my-component component in DOM
        this.renderComponent = true;
      });
    },

    updateValue(value) {
      console.log(value);
      this.$set(this.model, 'color', value.hex);
      // this.model.color = value.hex;
    },
  },
};

export default mixinColors;
